import React, { FunctionComponent } from 'react'
import { useSelector } from 'react-redux'
import { Company } from '../../../pages/DashBoard/DashBoardScreen'
import { MainState } from '../../../redux/reducers'
import { ProductData } from '../../../redux/requests/products/product.types'
import * as S from './styled'
enum Product {
  EGG = 'EGGS',
  WHEAT = 'WHEAT',
  OATS = 'OATS',
  RAPESEED = 'RAPESEED',
}
type OwnProps = {
  setWeeks: React.Dispatch<React.SetStateAction<number>>
  setPackeryFilter: React.Dispatch<React.SetStateAction<Company>>
  productData: ProductData[]
  packeryFilter: Company
}
const currentProductTranslations = {
  [Product.EGG]: 'eggs',
  [Product.OATS]: 'oats',
  [Product.WHEAT]: 'wheat',
  eggs: 'eggs',
  oats: 'oats',
  raps: 'raps',
}

type Props = OwnProps

export const PackeryDropDown: FunctionComponent<Props> = ({
  setPackeryFilter,
  productData,
  packeryFilter,
}) => {
  const currentProduct = useSelector((state: MainState) => state.misc.product)
  const availablePackeries = Array.from(
    new Set(
      productData
        .map(product => {
          if (product.product === currentProductTranslations[currentProduct ?? '']) {
            return product.buyer
          }
          return ''
        })
        .filter(item => item),
    ),
  )

  function changeHandler(event: any) {
    const value = event.target.options[event.target.options.selectedIndex].value
    setPackeryFilter(value)
  }
  return (
    <S.Card>
      <S.Text>Köpare:</S.Text>
      <S.DropDown onChange={changeHandler} value={packeryFilter}>
        <option value={Company.ALL}>Alla</option>
        {availablePackeries.map(item => (
          <option key={item} value={item}>
            {item}
          </option>
        ))}
        {}
      </S.DropDown>
    </S.Card>
  )
}

export default PackeryDropDown
